import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Grid, Header, Image } from 'semantic-ui-react';
import PhotoWidgetDropzone from './PhotoWidgetDropzone';
import{Cropper} from 'react-cropper';
import PhotoImageCropper from './PhotoImageCropper';
import { observer } from 'mobx-react-lite';

interface Props{

    loading:boolean;
    uploadPhoto:(file:File) =>void;

}

export default function PhotoUploadWidget({loading, uploadPhoto}:Props) {

    const[files,setFiles] = useState<any>([]);
    const[cropper, setCropper] = useState<Cropper>();

    function onCrop()
    {
        if(cropper)
        {
          cropper.getCroppedCanvas().toBlob(blob => {
            if (blob) {
                // Convert Blob to File
                const file = new File([blob], 'cropped-image.png', { type: 'image/png' });
                uploadPhoto(file);
            }
        });
        }
    }

    useEffect(() => {
        return () => {
            files.forEach((file: any) => URL.revokeObjectURL(file.preview))
        }
    }, [files])

  return (
    <Grid>
      <Grid.Column width={4}>
        <Header sub color='teal' content='Step 1 - Add Photo' />
        <PhotoWidgetDropzone setFiles={setFiles}/>
      </Grid.Column>
      <Grid.Column width={1} />
      <Grid.Column width={4}>
        <Header sub color='teal' content='Step 2 - Resize image' />
        {files && files.length > 0 && (
            <PhotoImageCropper setCropper={setCropper} imagePreview={files[0].preview}/>
        )}
      </Grid.Column>
      <Grid.Column width={1} />
      <Grid.Column width={4}>
        <Header sub color='teal' content='Step 3 - Preview & Upload' />
        {files && files.length>0 &&
        <>
        <div className='img-preview' style={{minHeight:200, overflow:'hidden'}} />
        <Button.Group >
            <Button loading={loading}  onClick={onCrop} positive icon='check' />
            <Button disabled={loading} onClick={() => setFiles([])} icon='close' />
        </Button.Group>
        </>
        }
      </Grid.Column>
    </Grid>
  )
}